/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_LoadingInputs */

const en_admin_footer_badges_loading = /** @type {(inputs: Admin_Footer_Badges_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading badges...`)
};

/**
* | output |
* | --- |
* | "Loading badges..." |
*
* @param {Admin_Footer_Badges_LoadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_loading = /** @type {((inputs?: Admin_Footer_Badges_LoadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_LoadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_loading(inputs)
});
export { admin_footer_badges_loading as "admin.footer_badges.loading" }